module.exports = __webpack_public_path__ + "img/btn3.f83ece6b.jpeg";